import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-variables-second-intelligence-evolution',
  templateUrl: './select-variables-second-intelligence-evolution.component.html',
  styleUrls: ['./select-variables-second-intelligence-evolution.component.scss']
})
export class SelectVariablesSecondIntelligenceEvolutionComponent {

  public items: any[] = [
    { name: 'Sin Variable', value: '' },
    { name: 'Vol de Venta', value: 'volume' },
    { name: 'Precio Compra', value: 'purchase_price' },
    { name: 'Margen $', value: 'purchase_margin' },
    { name: 'Precio TAR', value: 'price_tar' }
  ];

  public variableSelected: any = [];
  variableSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.variableSelected$ = sharedService.sharedVariableSecondEvolution.subscribe((variableSelected: string) => {
      this.variableSelected = variableSelected;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    // Normalize the event value (can be primitive, array, or object)
    let value: any;
    if (event === null || event === undefined) {
      value = null;
    } else if (Array.isArray(event)) {
      value = event.length > 0 ? event[0] : null;
    } else if (typeof event === 'object' && event.value !== undefined) {
      value = event.value;
    } else {
      value = event;
    }
    
    this.variableSelected = value;
    this.sharedService.nextVariableSecondEvolution = this.variableSelected;
  }

  isSelected(option: any): boolean {
    if (!this.variableSelected || (Array.isArray(this.variableSelected) && this.variableSelected.length === 0) || this.variableSelected === '' || this.variableSelected === null || this.variableSelected === undefined) {
      return false;
    }
    
    // Extract the primitive selected value
    let selectedValue: any;
    if (Array.isArray(this.variableSelected)) {
      selectedValue = this.variableSelected.length > 0 ? this.variableSelected[0] : null;
    } else if (typeof this.variableSelected === 'object' && this.variableSelected !== null) {
      selectedValue = this.variableSelected.value !== undefined ? this.variableSelected.value : this.variableSelected;
    } else {
      selectedValue = this.variableSelected;
    }
    
    // Normalize selectedValue if it's an object
    if (typeof selectedValue === 'object' && selectedValue !== null) {
      selectedValue = selectedValue.value !== undefined ? selectedValue.value : selectedValue;
    }
    
    return option.value === selectedValue;
  }

}
